import { cn } from '@localagent/ui/lib/utils';
import { usePlatform } from '@localagent/platform';
import { ThemeToggle } from '../ThemeToggle';
import { BridgeConnectionIndicator } from '../shogunchop/BridgeConnectionIndicator';
import { IndexingProgressIndicator } from '../search/IndexingProgressIndicator';
import { useIndexingProgressStream } from '../../hooks/useIndexingProgressStream';
import { DownloadForMac } from '../DownloadForMac';
import { WebDesktopHandoff } from '../../lifecycle/WebDesktopHandoff';
import { MacTrafficLightSlot } from './MacTrafficLightSlot';
import appIconUrl from '../../assets/app-icon.svg';

export function TitleBarWordmark() {
  return (
    <div className="flex items-center gap-2" data-testid="titlebar-wordmark">
      <h1 className="text-sm font-semibold">ShogunChop</h1>
      <img
        src={appIconUrl}
        alt=""
        width={20}
        height={20}
        data-testid="app-icon"
        className="h-5 w-5"
      />
    </div>
  );
}

export function TitleBarStatusCluster() {
  return (
    <div
      role="status"
      aria-label="System status"
      data-testid="titlebar-status-cluster"
      className="flex items-center gap-2 rounded-md px-2 py-1"
    >
      <BridgeConnectionIndicator />
      <IndexingProgressIndicator />
    </div>
  );
}

export function TitleBar() {
  useIndexingProgressStream();
  const platform = usePlatform();
  const isMac = platform.osPlatform === 'darwin';
  const isDesktop = platform.type === 'desktop';

  return (
    <div
      data-testid="app-titlebar"
      className="flex h-12 items-stretch border-b bg-background"
    >
      {isMac && <MacTrafficLightSlot />}
      <div
        className={cn(
          'flex min-w-0 flex-1 items-center justify-between px-4',
          isDesktop && 'titlebar',
        )}
      >
                <div className="flex items-center gap-3">
                  <TitleBarWordmark />
                </div>

        <div className="flex items-center gap-2">
          {isDesktop ? <DownloadForMac compact /> : <WebDesktopHandoff />}
          <TitleBarStatusCluster />
          <ThemeToggle />
        </div>

        {isDesktop && !isMac && (
          <div className="flex items-center gap-1">
            <button
              className="flex h-8 w-8 items-center justify-center hover:bg-accent"
              aria-label="Minimize"
            >
              <span className="text-lg">−</span>
            </button>
            <button
              className="flex h-8 w-8 items-center justify-center hover:bg-accent"
              aria-label="Maximize"
            >
              <span className="text-lg">□</span>
            </button>
            <button
              className="flex h-8 w-8 items-center justify-center hover:bg-destructive hover:text-destructive-foreground"
              aria-label="Close"
            >
              <span className="text-lg">×</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
